import { isString } from 'lodash';

export interface ErrorResponse {
    message: string;
    error?: string;
    statusCode?: number;
}

/**
 * Parses and validates error message string or object
 * @param error - Error message string or object
 * @returns Parsed error response object
 */
export function parseErrorMessage(error: any): ErrorResponse {
    try {
        // If error is already an object, validate its structure
        if (typeof error === 'object' && error !== null) {
            return validateErrorStructure(error);
        }

        // If error is a string, try to parse it as JSON
        if (isString(error)) {
            try {
                const parsedError = JSON.parse(error);
                return validateErrorStructure(parsedError);
            } catch (e) {
                // If string is not valid JSON, return it as message
                return {
                    message: error,
                    statusCode: 500
                };
            }
        }

        // Default error response
        return {
            message: 'Unknown error occurred',
            statusCode: 500
        };
    } catch (e) {
        return {
            message: 'Error parsing error message',
            error: e.message,
            statusCode: 500
        };
    }
}

/**
 * Validates error response structure
 * @param error - Error object to validate
 * @returns Validated error response
 */
function validateErrorStructure(error: any): ErrorResponse {
    const response: ErrorResponse = {
        message: 'Unknown error occurred',
        statusCode: 500
    };

    if (error.message && isString(error.message)) {
        response.message = error.message;
    }

    if (error.error && isString(error.error)) {
        response.error = error.error;
    }

    if (error.statusCode && typeof error.statusCode === 'number') {
        response.statusCode = error.statusCode;
    }

    return response;
}
